import { Box } from '@mui/material';
import { InspectionRouter } from '@/components';
import { DefaultLayout } from '@/layouts';
import { useFetchCookies, useRouter } from '@/hooks';
import { PageLoader } from '@/components/shared/PageLoader';

export const InspectionPage = () => {
  const router = useRouter();
  const { inspection } = router.query;
  const cookiesFetched = useFetchCookies();

  if (!inspection || Array.isArray(inspection)) {
    return <div>Please specify inspection id</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <DefaultLayout>
      <InspectionRouter inspectionId={inspection} />
    </DefaultLayout>
  );
};
